export const OverallPerformanceConstants = {
  LOCAL_COMPARE_PERIOD_TABLE_DATA: 'local_compare_period_table_data',
  COMPARE_PERIOD_TABLE_DATA: 'compare_period_table_data',
  LOCAL_YTD_VIEW_TABLE_DATA: 'local_ytd_view_table_data',
  YTD_VIEW_TABLE_DATA: 'ytd_view_table_data',
  REGION_YTD_VIEW_TABLE_DATA: 'region_ytd_view_table_data',
  REGION_COMPARE_PERIOD_TABLE_DATA: 'region_compare_period_table_data',
  OVERALL_PERFORMANCE_REGION_QUERY_LOCAL_SPEND_COMBINED:
    'overall_performance_region_query_local_spend_combined',
  OVERALL_PERFORMANCE_REGION_QUERY_BRANCH_COMBINED:
    'overall_performance_region_query_branch_combined',
  OVERALL_PERFORMANCE_BRANCHES_FILE_NAME: 'overall_performance_branches.xlsx',
  OVERALL_PERFORMANCE_BRANCHES_FILE_NAME_SUB_BRANCH: 'sub_branch_overall_performance_branches.xlsx',
  OVERALL_PERFORMANCE_LOCAL_SPEND_BRANCHES_FILE_NAME:
    'overall_performance_branches_local_spend.xlsx',
  OVERALL_PERFORMANCE_LOCAL_SPEND_BRANCHES_FILE_NAME_SUB_BRANCH:
    'sub_branch_overall_performance_branches_local_spend.xlsx',
  OVERALL_PERFORMANCE_REGION_FILE_NAME: 'overall_performance_regions.xlsx',
};
